/**
 * Placeholder Pages - For routes that don't have full implementation yet
 * These provide basic UI with "Coming Soon" message
 * 
 * CLEANED: ExamsPage, TimetablePage, TransportPage removed (replaced by full implementations)
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

// Generic Coming Soon Page
function ComingSoonPage({ title, icon = '🚧' }) {
  const { language } = useLanguage();
  
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
      <div className="text-6xl mb-4">{icon}</div>
      <h1 className="text-2xl font-bold text-gray-800 mb-2">{title}</h1>
      <p className="text-gray-500 mb-6">
        {language === 'hi' ? 'यह feature जल्द आ रहा है!' : 'This feature is coming soon!'}
      </p>
      <Link 
        to="/dashboard" 
        className="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition"
      >
        {language === 'hi' ? '← डैशबोर्ड पर जाएं' : '← Go to Dashboard'}
      </Link>
    </div>
  );
}

// Calendar Page
export function CalendarPage({ token }) {
  return <ComingSoonPage title="Calendar / कैलेंडर" icon="🗓️" />;
}

// Parent Portal Dashboard
export function ParentPortalDashboard({ token, user }) {
  const { language } = useLanguage();
  
  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-2xl p-6 text-white">
        <h1 className="text-2xl font-bold mb-2">
          {language === 'hi' ? '👨‍👩‍👧‍👦 पेरेंट पोर्टल' : '👨‍👩‍👧‍👦 Parent Portal'}
        </h1>
        <p className="text-green-100">
          {language === 'hi' ? 'अपने बच्चे की progress track करें' : 'Track your child\'s progress'}
        </p>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Link to="/portal-attendance" className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition">
          <div className="text-3xl mb-2">✅</div>
          <span className="text-gray-700 font-medium">{language === 'hi' ? 'उपस्थिति' : 'Attendance'}</span>
        </Link>
        <Link to="/portal-fees" className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition">
          <div className="text-3xl mb-2">💰</div>
          <span className="text-gray-700 font-medium">{language === 'hi' ? 'शुल्क' : 'Fees'}</span>
        </Link>
        <Link to="/portal-announcements" className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition">
          <div className="text-3xl mb-2">📢</div>
          <span className="text-gray-700 font-medium">{language === 'hi' ? 'सूचनाएं' : 'Announcements'}</span>
        </Link>
        <Link to="/portal-complaints" className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition">
          <div className="text-3xl mb-2">📨</div>
          <span className="text-gray-700 font-medium">{language === 'hi' ? 'शिकायतें' : 'Complaints'}</span>
        </Link>
        <Link to="/portal-bus-tracking" className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition border-2 border-green-200" data-testid="bus-tracking-link">
          <div className="text-3xl mb-2">🚌</div>
          <span className="text-green-700 font-medium">{language === 'hi' ? 'बस ट्रैकिंग' : 'Bus Tracking'}</span>
          <div className="text-[10px] text-green-500 font-semibold mt-1">LIVE</div>
        </Link>
      </div>
    </div>
  );
}

// Portal Pages
export function PortalAttendancePage({ token, user }) {
  return <ComingSoonPage title="My Attendance / मेरी उपस्थिति" icon="✅" />;
}

export function PortalFeesPage({ token, user }) {
  return <ComingSoonPage title="My Fees / मेरा शुल्क" icon="💰" />;
}

export function PortalAnnouncementsPage({ token, user }) {
  return <ComingSoonPage title="Announcements / सूचनाएं" icon="📢" />;
}

export function PortalComplaintsPage({ token, user }) {
  return <ComingSoonPage title="My Complaints / मेरी शिकायतें" icon="📨" />;
}

// Leave Requests Page (Teacher view)
export function LeaveRequestsPage({ token, user }) {
  return <ComingSoonPage title="Leave Requests / छुट्टी अनुरोध" icon="📋" />;
}
